import {
  Printer, ChefHat, Ban, Percent, StickyNote, Tag, Repeat2,
} from 'lucide-react';

// Touch-Mode action toolbar (iter378) — Foodics-parity row of
// cashier actions. Mirrors the reference images: Print, Kitchen,
// Void, Discount, Notes, Tags, More. Each is a soft-tinted tile
// with icon+label so it works on a touch terminal.
// iter893 — Added a dedicated "Reprint Last" tile so cashiers can
// re-print the most recent completed order with a single tap
// (customer walking back to the counter asking for their receipt).
export const PosActionToolbar = ({
  onPrintReceipt,
  onSendKitchen,
  onVoidCart,
  onOpenDiscount,
  onOpenNotes,
  onOpenPopular,
  onReprintLast,
  hiddenKeys = [],
}) => {
  const tiles = [
    { key: 'print', icon: Printer, label: 'Print',
      cls: 'bg-violet-50 hover:bg-violet-100 text-violet-700 dark:bg-violet-950/30 dark:hover:bg-violet-900/40 dark:text-violet-300',
      onClick: onPrintReceipt },
    { key: 'reprint', icon: Repeat2, label: 'Reprint Last',
      cls: 'bg-indigo-50 hover:bg-indigo-100 text-indigo-700 dark:bg-indigo-950/30 dark:hover:bg-indigo-900/40 dark:text-indigo-300',
      onClick: onReprintLast },
    { key: 'kitchen', icon: ChefHat, label: 'Kitchen',
      cls: 'bg-orange-50 hover:bg-orange-100 text-orange-700 dark:bg-orange-950/30 dark:hover:bg-orange-900/40 dark:text-orange-300',
      onClick: onSendKitchen },
    { key: 'void', icon: Ban, label: 'Void',
      cls: 'bg-rose-50 hover:bg-rose-100 text-rose-700 dark:bg-rose-950/30 dark:hover:bg-rose-900/40 dark:text-rose-300',
      onClick: onVoidCart },
    { key: 'discount', icon: Percent, label: 'Discount',
      cls: 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700 dark:bg-emerald-950/30 dark:hover:bg-emerald-900/40 dark:text-emerald-300',
      onClick: onOpenDiscount },
    { key: 'notes', icon: StickyNote, label: 'Notes',
      cls: 'bg-amber-50 hover:bg-amber-100 text-amber-700 dark:bg-amber-950/30 dark:hover:bg-amber-900/40 dark:text-amber-300',
      onClick: onOpenNotes },
    { key: 'tags', icon: Tag, label: 'Tags',
      cls: 'bg-sky-50 hover:bg-sky-100 text-sky-700 dark:bg-sky-950/30 dark:hover:bg-sky-900/40 dark:text-sky-300',
      onClick: onOpenPopular },
  ];
  // iter960 — Branch-specific ON/OFF: hide any tile whose key is in the
  // DB-backed toolbar-config `hidden` array (admin/manager-set).
  // (The former "More" tile only duplicated the canonical top "Orders"
  // entry and was removed in Phase A.1; order history lives in the top bar.)
  const visibleTiles = tiles.filter((t) => !hiddenKeys.includes(t.key));
  return (
    <div className="px-4 pt-3">
      <div className="grid grid-cols-4 lg:grid-cols-8 gap-1.5 sm:gap-2">
        {visibleTiles.map(({ key, icon: Icon, label, cls, onClick }) => (
          <button
            key={key}
            onClick={onClick}
            className={`group flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 ${cls}`}
            data-testid={`pos-action-${key}`}
            title={label}
          >
            <Icon size={18} />
            <span className="text-[10px] font-bold uppercase tracking-wide">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PosActionToolbar;
